import axios from 'axios'
import env from '@env'

// 排队点餐API
export default class QueueAPI {
  /**
   * 获取门店排队叫号配置
   */
  static async getCallConfig (params: any) {
    const url = `${env.ORDERJMOBILE}/getCallConfig`
    return axios.post(url, params).then((res: any) => {
      return res.error ? res : res.result
    })
  }
  /**
   * 取号
   */
  static async callNono (params: any) {
    const url = `${env.ORDERJMOBILE}/getCallNono`
    return axios.post(url, params).then((res: any) => {
      return res.error ? res : res.result
    })
  }
  /**
   * 获取叫号信息
   */
  static async getCallInfo (params: any) {
    const url = `${env.ORDERJMOBILE}/searchCallNo`
    return axios.post(url, params).then((res: any) => {
      return res.error ? res : res.result
    })
  }
  /**
   * 入桌
   */
  static async checkinCallByBuyer (params: any) {
    const url = `${env.ORDERJMOBILE}/checkinCallByBuyer`
    return axios.post(url, params).then((res: any) => {
      return res.error ? res : res.result
    })
  }
  /**
   * 预点单
   */
  static async saveBeforeCalling (params: any) {
    const url = `${env.ORDERJMOBILE}/saveBeforeCalling`
    return axios.post(url, params).then((res: any) => {
      return res.error ? res : res.result
    })
  }
}
